import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MateriaService } from '../../../services/materia.service';

@Component({
  selector: 'app-materia',
  templateUrl: './materia.component.html',
  styleUrls: ['./materia.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MateriaComponent implements OnInit {
  id: number;
  materia: any;

  constructor(
    private route: ActivatedRoute,
    private materiaService: MateriaService,
    private _location: Location
  ) {}

  ngOnInit() {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    this.materiaService.getById(this.id).subscribe(
      (mat) => {
        this.materia = mat;
      },
      (error) => {
        if (error.status == 404) window.location.replace('/404');
      }
    );
  }

  backClicked() {
    this._location.back();
  }

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }
}
